import { render, staticRenderFns } from "./buttonAreas.vue?vue&type=template&id=4ddf2601"
import script from "./buttonAreas.vue?vue&type=script&lang=js"
export * from "./buttonAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports